/**
 * The construction logo is sticky and compacts once it is stuck to the top;
 * everything scrolling up behind it is masked from the artwork's bottom edge, so
 * the text reads as a box that never runs under the logo.
 */

export function initScrollBox() {
	const logo = document.querySelector('.coming-soon__logo');
	if (!logo) return;

	const artwork = logo.querySelector('picture, img') || logo;
	const boxed = [
		...document.querySelectorAll('.coming-soon > :not(.page-background, .coming-soon__logo)'),
		...document.querySelectorAll('.site-footer'),
	];

	document.documentElement.classList.add('has-scroll-box');

	let frame = 0;
	let resizing = false;
	const update = () => {
		frame = 0;
		// The box keeps its height while the artwork shrinks, so this can't flicker at the threshold.
		const stuck = logo.getBoundingClientRect().top <= parseFloat(getComputedStyle(logo).top) + 1;
		logo.classList.toggle('is-compact', stuck);
		const edge = artwork.getBoundingClientRect().bottom;
		boxed.forEach((el) => {
			el.style.setProperty('--box-cut', `${Math.round(edge - el.getBoundingClientRect().top)}px`);
		});
		// The edge moves with the logo while it shrinks, even when the page itself doesn't scroll.
		if (resizing) schedule();
	};
	const schedule = () => {
		if (!frame) frame = requestAnimationFrame(update);
	};

	artwork.addEventListener('transitionrun', () => {
		resizing = true;
		schedule();
	});
	artwork.addEventListener('transitionend', () => {
		resizing = false;
		schedule();
	});

	update();
	window.addEventListener('scroll', schedule, { passive: true });
	window.addEventListener('resize', schedule);
}
